import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function InvoiceInfoLine({ title, text, align = "left", fontSize = "10pt" }) {
  return (
    <SoftBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "row", md: "row" }}
      alignItems={{ xs: "flex-start" }}
      textAlign={{ xs: "left", md: "right" }}
      mt={{ xs: 0, md: 0 }}
    >
      <SoftBox width="30%">
        <SoftTypography
          variant="h6"
          color="secondary"
          fontWeight="medium"
          textAlign={align}
          fontSize={fontSize}
        >
          {title}
        </SoftTypography>
      </SoftBox>
      <SoftBox width="70%">
        <SoftTypography variant="h6" fontWeight="medium" textAlign={"right"} fontSize={fontSize}>
          {text}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

export default InvoiceInfoLine;
